/* eslint-disable sort-imports */
import { ENDPOINTS, RESPONSE } from 'config/api';
import fetch from 'app/utilities/fetch';
import JsonLd from 'app/components/partials/json-ld';
import Loader from 'app/components/partials/loader';
import NewsletterStrip from 'app/components/partials/newsletter-strip.container.js';
import NewsModel from 'app/models/news';
import Select from 'app/components/partials/select';
import Tabs from 'app/components/partials/tabs';
import Tile from 'app/components/partials/tile/index';
import { getNewsCollectionStructuredData } from 'app/utilities/seo';
import React, { useEffect, useState } from 'react';

const NEWS_TABS = [];

const NEWS_CATEGORY = [];

const News = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [articles, setArticles] = useState(null);
    const [featuredArticle, setFeaturedArticle] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(NEWS_CATEGORY[0] || null);

    const getArticles = async(includeFeatured = true, page = 1, category = null) => {
        try {
            const articlesData = await fetch(ENDPOINTS.NEWS(includeFeatured, page, category));
            if (articlesData && articlesData.featured && articlesData.featured.data && articlesData.featured.data.length !== 0) {
                setFeaturedArticle(new NewsModel({ attributes: articlesData.featured.data }));
            }

            if (articlesData && articlesData.data) {
                setArticles(articlesData.data.map((article) => new NewsModel(article)));
            }
        } catch (e) {
            if (e.status === RESPONSE.NOT_FOUND) {
                setArticles([]);
            }
        }
    };

    const getCategories = async() => {
        try {
            const categoriesData = await fetch(ENDPOINTS.NEWS_CATEGORIES);
            if (categoriesData && categoriesData.data) {
                // init NEWS_TABS and NEWS_CATEGORY
                NEWS_TABS.length = 0;
                // NEWS_TABS.push({ value: 'all-news', title: 'All news' });
                NEWS_CATEGORY.length = 0;
                // NEWS_CATEGORY.push({ value: 'all-news', label: 'All news' });

                categoriesData.data.forEach((category) => {
                    NEWS_TABS.push({ value: category.id, title: category.attributes.name });
                    NEWS_CATEGORY.push({ value: category.id, label: category.attributes.name });
                });
                setSelectedCategory(NEWS_CATEGORY[0]);
            }
        } catch (e) {
            // handle error
        }
    };

    const categoryChangeHandler = (event) => {
        setSelectedCategory(NEWS_CATEGORY.filter((category) => category.value === event.target.value)[0]);
    };

    const tabChangeHandler = (tabValue) => {
        setSelectedCategory(NEWS_CATEGORY.filter((category) => category.value === tabValue)[0]);
    };

    // TODO: currently only have all news catagory
    const renderNewsPageTabPanel = (tab) => (
        <div className="tiles-wrapper || constrain-width large">
            {/* invisible heading for accessibility only */}
            <h2 className="sr-only">{tab.title}</h2>
            {articles && articles.map((article, index) => <Tile key={index} type="news" isHorizontal={true} {...article.tile} />)}
        </div>
    );

    useEffect(async() => {
        try {
            await Promise.all([getCategories(), getArticles()]);
        } finally {
            setIsLoading(false);
        }
    }, []);

    useEffect(() => {
        return selectedCategory && getArticles(false, 1, selectedCategory.value);
    }, [selectedCategory]);

    const structuredData = getNewsCollectionStructuredData();

    if (isLoading) {
        return (
            <React.Fragment>
                <JsonLd data={structuredData} />
                <Loader />
            </React.Fragment>
        );
    }

    return (
        <div className="content-page || news-page">
            {/* invisible heading for accessibility only */}
            <h1 className="sr-only">Latest News</h1>
            <JsonLd data={structuredData} />
            <div className="content-blocks">
                {featuredArticle && (
                    <div className="content-block || constrain-width large">
                        {/* invisible heading for accessibility only */}
                        <h2 className="sr-only">Featured Article</h2>
                        <Tile type="news" isHero={true} isHorizontal={true} {...featuredArticle.tile} />
                    </div>
                )}
                {selectedCategory && (
                    <div className="content-block || news-container">
                        <div className="category-select || form || constrain-width large">
                            <label className="sr-only" htmlFor="news-category">News Category</label>
                            <Select
                                id="news-category"
                                name="category"
                                options={NEWS_CATEGORY}
                                value={selectedCategory.value}
                                onChangeHanlder={categoryChangeHandler}
                            />
                        </div>
                        {articles && <Tabs isNew={true} tabsList={NEWS_TABS} renderTabsPanel={renderNewsPageTabPanel} tabChangeHandler={tabChangeHandler} />}
                    </div>
                )}
            </div>
            <NewsletterStrip pageTitle="News" />
        </div>
    );
};

export default News;
